import { getTargetUrlAndAccessToken } from './commands/login/accessTokens'
import { doLogin } from './commands/login/login'
import { CustomComponentLibraryWrappedClient } from './customComponentLibraryWrappedClient'
import { Configuration } from './retool_client'
import { customComponentSupportLibraryVersion } from './version'

export type Header = {
  name: string,
  value: string
}

export const getCCLClient = async (
  askForUnixSocket: boolean,
  headers: string[] | undefined,
  instance = 'default',
  url?: string,
  accessToken?: string,
  pathToUnixSocket?: string,
  verbose = false,
): Promise<CustomComponentLibraryWrappedClient> => {

  let targetUrlAndToken;

  if (url && accessToken) {
    targetUrlAndToken = {
      url,
      accessToken,
      unixSocket: pathToUnixSocket,
    }
  } else {
    targetUrlAndToken = getTargetUrlAndAccessToken(instance)
  }

  if (!targetUrlAndToken) {
    const results = await doLogin(askForUnixSocket, headers ?? [], 'default')
    if (results.error) {
      throw new Error(results.error)
    } else {
      targetUrlAndToken = {
        url: results.url,
        accessToken: results.accessToken,
        unixSocket: results.unixSocket,
      }
    }
  }

  const headersToUse = {
    'X-Retool-Client-Version': `custom-component-support-${customComponentSupportLibraryVersion}`,
  }

  const givenHeaders = parseHeaders(headers ?? []) 
  givenHeaders?.forEach((h) => {
    headersToUse[h.name] = h.value
  })

  const configuration = new Configuration({
    basePath: `${targetUrlAndToken.url}/api/v2`,
    accessToken: targetUrlAndToken.accessToken,
    headers: headersToUse,
  })

  return new CustomComponentLibraryWrappedClient(configuration, targetUrlAndToken.unixSocket, verbose)
}

export const parseHeaders = (headers: string[]): Header[] => {
  return headers.map((h) => {
    // Headers are defined in web standards to be split on the first occurence of :
    const [name, value] = h.split(/:(.+)/);
    return {
      name, value
    }
  })
}
